import request from "@/utils/request";

// 发送短信验证码接口
export function getSendMsg(data) {
  return request({
    url: "/apis/sra/store/users/signup/sendMsg", // 后端接口
    method: "post",
    data
  });
}

// 校验联系人手机号接口
export function getCheckMobile(data) {
  return request({
    url: "/apis/sra/store/users/signup/checkMobile", // 后端接口
    method: "post",
    data
  });
}

// 新增商家联系人接口
export function getSaveContact(data) {
  return request({
    url: "/apis/sra/store/users/signup/saveContact", // 后端接口
    method: "post",
    data
  });
}

// 根据手机号查询所属公司接口
export function qryComByPhone(data) {
  return request({
    url: "/apis/sra/store/users/signup/qryComByPhone", // 后端接口
    method: "post",
    data
  });
}

//获取拼图滑块图片验证
export function getImageVerifyCode (data) {
  return request({
    url: '/apis/sra/captcha/users/signup/getImageVerifyCode.do', // 后端接口
    method: 'get',
    data
  })
}

export function validAuthCode (data) {
  return request({
    url: '/apis/sra/spc/users/signup/validAuthCode', // 后端接口
    method: 'post',
    data
  })
}

